import  { EventManager }  from 'library-event-manager';

let eventManager = new EventManager();

export enum EvtNameSpace {
  Auth,
  UI
}
export enum EvtType {
  LoggedIn,
  LoggedOut,
  OpenLoginModal
}

export class Evt  {
  static dispatch = (namespace: EvtNameSpace | string, action: EvtType | string, ...args: any) => {
    eventManager.event(namespace as string, action as string, ...args);
  }

  static on = (namespace: EvtNameSpace | string, action: EvtType | string, delegateFunction: any, oneTime?: boolean) => {
    eventManager.addEventListener(namespace as string, action as string, delegateFunction, oneTime);
  }

  static off = (namespace: EvtNameSpace | string, action: EvtType | string, delegateFunction: any) => {
    eventManager.removeEventListener(namespace as string, action as string, delegateFunction);
  }
}
